import React, { PureComponent } from 'react';
import TrackChangesRoundedIcon from '@material-ui/icons/TrackChangesRounded';
import { AddTestDialog, AddTestDialogPopUp } from '../../../addTestDialog';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import courseManagementServices from '../../../../../service/courseManagementServices';

interface MidTermTestProps {
  date: Date;
  subjects: [
    {
      name: string;
      chapterCount: number;
    }
  ];
  packageData?: any;
  match?: any;
  handleAddTest: (data: any) => void;
}
const subjectNameStyles = {
  fontSize: '20px',
  lineHeight: '27px',
  color: '#333',
  marginRight: '4px',
  verticalAlign: 'middle',
};
const dateStyle = {
  color: '#999',
  fontSize: '16px',
  lineHeight: '18px',
  marginBottom: '10px',
  display: 'inline-block',
};
const bullets = {
  color: '#C4C4C4',
  padding: '0px 10px',
  marginTop: '5px',
};
interface AddTestDialogProps {
  title: string;
  dropDownStringArray: string[];
  textFieldStringArray: { title: string; name: string; value: string }[];
  dialogButtonName: string;
  isExistingTest: boolean;
  durationAttemptRevision: { title: string; name: string; value: string, placeholder?: string }[];
  buttonName: string;
  isRequiredMapTest: boolean;
  isExistingAndScheduledTest: boolean;
  isRequiredDate: boolean;
  isEmpty?: boolean;
}

interface State {
  addTestDialogProps: AddTestDialogProps;
  courseDetails: any;
}

export class MidTermTest extends PureComponent<MidTermTestProps, State> {
  constructor(props: MidTermTestProps) {
    super(props);
    this.state = {
      addTestDialogProps: {
        title: 'Add Test',
        dropDownStringArray: ['test'],
        textFieldStringArray: [
          { title: 'Test Name', name: 'testName', value: 'displayName' },
          { title: 'Test Syllabus', name: 'testSyllabus', value: 'paperDetail.syllabus.text' },
        ],
        dialogButtonName: 'Add test',
        isExistingTest: true,
        durationAttemptRevision: [
          { title: 'Duration', name: 'duration', value: 'duration', placeholder: 'Enter duration' },
          { title: 'Max Attempt', name: 'maxAttempt', value: 'maxAttempt', placeholder: 'Enter max attempt' },
          { title: 'Block Revision Time for This Test', name: 'blockRevisionTime', value: 'blockRevisionTime' },
        ],
        buttonName: '+ Add Test',
        isRequiredMapTest: true,
        isExistingAndScheduledTest: true,
        isRequiredDate: true,
      },
      courseDetails: {},
    };
  }

  componentDidMount() {
    courseManagementServices.getCourseDetails(_.get(this.props.match, 'params.id', '')).then((res) => {
      this.setState({
        courseDetails: res,
      });
    });
  }

  componentDidUpdate(prevProps: MidTermTestProps) {
    if (prevProps.packageData !== this.props.packageData) {
      // console.log('::::::::update::::::::::',this.props.packageData);
    }
  }

  handleAddTestDialogClick = () => {
    // console.log('::::::Clicked:::::')
    this.setState((prevProps: any) => ({
      showAddTestDialog: !prevProps.showAddTestDialog,
    }));
  };

  render() {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const date = new Date(this.props.date.toString());
    const day = date.getDate();

    const month = months[date.getMonth()];
    const year = date.getFullYear();
    const { addTestDialogProps } = this.state;
    const { handleAddTest } = this.props;

    return (
      <div
        style={{
          borderBottom: '1px solid lightgrey',
          padding: `1% 3%`,
        }}
      >
        <div>
          <span>
            <TrackChangesRoundedIcon color='primary' />
            &nbsp;
          </span>
          <span style={subjectNameStyles}>Midterm Test</span>
          <span style={bullets}>&bull;</span>
          <span style={dateStyle}> {`${day} ${month} ${year}`}</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span style={{ display: 'flex', marginLeft: '1.5%' }}>
            {this.props.subjects.map((subject: { name: string; chapterCount: number }) => (
              <span style={{ fontSize: '14px', color: '#666' }}>{`${subject.chapterCount} chapters in ${
                subject.name
              },  `}&nbsp;</span>
            ))}
          </span>
          <span>
            <a href='#' style={{ fontSize: '14px', color: '#1d7dea', fontWeight: 700, textDecoration: 'none' }}>
              View Test
            </a>
            {/* </span> */}

            {/* <span>
          {this.props.subjects.map((subject: { name: string; chapterCount: number }) => (
            <span style={{ fontSize: '0.8em' }}>{`${subject.chapterCount} chapters in ${
              subject.name
            }  `}</span>
          ))}
        </span> */}
            {/* <span> */}
            {/* <a href='#'>View Test</a> */}
            {/* <a><span onClick={this.handleAddTestDialogClick}>+ Add Test</span></a> */}

            {/* Start @frontend use this line for Add Test CTA */}
            {/* &nbsp;<a style={{fontSize: '14px', color: '#1d7dea', fontWeight: 700, textDecoration: 'none'}}>+ Add Test</a> */}
            {/* End @frontend use this line for Add Test CTA */}

            {
              <AddTestDialogPopUp
                title={addTestDialogProps.title}
                dropDownStringArray={addTestDialogProps.dropDownStringArray}
                textFieldStringArray={addTestDialogProps.textFieldStringArray}
                dialogButtonName={addTestDialogProps.dialogButtonName}
                isExistingTest={addTestDialogProps.isExistingTest}
                durationAttemptRevision={addTestDialogProps.durationAttemptRevision}
                buttonName={addTestDialogProps.buttonName}
                isRequiredMapTest={addTestDialogProps.isRequiredMapTest}
                isExistingAndScheduledTest={addTestDialogProps.isExistingAndScheduledTest}
                isRequiredDate={addTestDialogProps.isRequiredDate}
                courseId={_.get(this.props.match, 'params.id', '')}
                courseDetails={this.state.courseDetails}
                handleAddTest={handleAddTest}
              />
            }
          </span>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  // console.log(':::::::::::State:::::::::::',state);
  return {
    packageData: _.get(state, 'courseMangementData.contentManagementData.packageByIdData.packageData', {}),
  };
};

const mapDispatchToProps = (dispatch: any) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(MidTermTest);
